export const TOGGLE_ADVANCED_MODAL = 'TOGGLE_ADVANCED_MODAL';
export const toggleAdvancedModal = () =>({
  type: TOGGLE_ADVANCED_MODAL,
})


/** WEBPACK FOOTER **
 ** ./src/app/modules/advancedSearch/actions.js
 **/